<script setup lang="ts">
/**
 * NavLockup — the fanned NavMark beside a two-color "MI EUCHRE" wordmark, with an
 * optional kicker subtitle. Ported from logos.jsx NavLockup. Reversed by default
 * (for dark bars / felt / paneling). The wordmark block carries the
 * `nav-lockup__text` class so chrome (e.g. a collapsing sidebar) can hide it.
 */
import { computed } from 'vue'
import { BK } from './tokens'
import NavMark from './NavMark.vue'

const props = withDefaults(
  defineProps<{ h?: number; reversed?: boolean; wordmark?: boolean; subtitle?: string }>(),
  { h: 40, reversed: true, wordmark: true, subtitle: '' },
)

const lockupStyle = computed(() => ({ gap: `${props.h * 0.42}px` }))
const miColor = computed(() => (props.reversed ? BK.gold : BK.barn))
const euchreColor = computed(() => (props.reversed ? BK.paper : BK.ink))
const wordStyle = computed(() => ({ fontSize: `${props.h * 0.62}px` }))
const subStyle = computed(() => ({
  color: props.reversed ? 'rgba(217,164,65,.85)' : BK.walnut,
  fontSize: `${Math.max(props.h * 0.23, 10)}px`,
}))
</script>

<template>
  <div class="nav-lockup" :style="lockupStyle">
    <NavMark :h="h" :reversed="reversed" />
    <div v-if="wordmark" class="nav-lockup__text">
      <div class="nav-lockup__wordmark" :style="wordStyle">
        <span :style="{ color: miColor }">MI</span> <span :style="{ color: euchreColor }">EUCHRE</span>
      </div>
      <div v-if="subtitle" class="nav-lockup__subtitle bk-kicker" :style="subStyle">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-lockup {
  display: flex;
  align-items: center;
}
.nav-lockup__text {
  line-height: 0.92;
}
.nav-lockup__wordmark {
  font-family: var(--font-display);
  font-weight: 700;
  letter-spacing: -0.02em;
  white-space: nowrap;
}
.nav-lockup__subtitle {
  margin-top: 4px;
  letter-spacing: 0.18em;
}
</style>
